<template>
  <div class="app">
    <router-view></router-view>

    <button @click="showChat = true" class="cursor-pointer chat-button mg-l-0 d-flex c-btn_started typography typography_size_title-1 typography_family_semi">
      <svg class="mg-t-auto mg-b-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="19" height="19" aria-hidden="true">
        <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"></path>
        <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z"></path>
      </svg>
    </button>

    <vChat :showChat="showChat" @closeChat="showChat = false" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vChat from "./components/vChat.vue";

export default {
  components: {
    vChat,
  },
  data() {
    return {
      showChat: false,
    };
  },
  methods: {
    ...mapActions(["identification"]),
    initReferral() {
      if (typeof window !== "undefined") {
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        });
        if (params.partner_code !== null) {
          localStorage.setItem("partnerСode", params.partner_code);
        }
      }
    },
  },
  created() {
    if (this.$route.query.chat !== undefined) {
      this.showChat = true;
    }
  },
};
</script>
<style>
.chat-button {
  position: fixed;
  bottom: 50px;
  right: 20px;
  z-index: 4;
  padding: 14px 14px!important;
  border-radius: 50%!important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}
</style>